import { render, staticRenderFns } from "./CancelBooking.vue?vue&type=template&id=298aed9a&scoped=true"
import script from "./CancelBooking.vue?vue&type=script&lang=ts"
export * from "./CancelBooking.vue?vue&type=script&lang=ts"
import style0 from "./CancelBooking.vue?vue&type=style&index=0&id=298aed9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298aed9a",
  null
  
)

export default component.exports